import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@digdir/designsystemet-react";
import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "react-oidc-context";

export const Route = createFileRoute("/debug")({
  component: RouteComponent,
});

function RouteComponent() {
  const { user } = useAuth();
  if (import.meta.env.PROD) {
    return;
  }
  return (
    <Table className="max-w-max rounded-md m-8" data-color="unbranded">
      <TableBody>
        <TableRow>
          <TableCell>
            <strong>App Version</strong>
          </TableCell>
          <TableCell>{__APP_VERSION__}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>Commit Hash</strong>
          </TableCell>
          <TableCell>{__COMMIT_HASH__}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>Access token</strong>
          </TableCell>
          <TableCell>
            <Button
              variant="tertiary"
              onClick={async () => {
                await navigator.clipboard.writeText(user?.access_token || "");
              }}
            >
              Kopier
            </Button>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}
